import React from 'react';
const { REACT_APP_URI = '/' } = process.env
const withLoginCheck = (WrappedComponent) => {
    return class extends React.Component {
        componentDidMount() {
            fetch(`${REACT_APP_URI}/accounts/loginOrNot/`, { credentials: 'include' })
                .then(res => {
                    const { status } = res
                    if (status === 200) {
                        // this.props.dispatch({ type: 'setUser', auth: 'isSignIn',  })
                        // fetch(`${REACT_APP_URI}/accounts/userInfo/`, { credentials: 'include' })
                        //     .then(res => res.json())
                        //     .then(({ email }) => this.props.dispatch({ type: `emailInput`, email: email }))
                        return res.json()
                    }
                    if (status === 603) throw this.props.dispatch({ type: 'setAuth', auth: 'notSignIn' })
                })
                .then(res => this.props.dispatch({ 
                    type: 'setUser', 
                    auth: 'isSignIn', 
                    plan: res.plan, 
                    isTrialing: res.isTrialing, 
                    canITrial: res.canITrial,
                    nextPayDate: res.nextPayDate}))
                .then(() => {
                    fetch(`${REACT_APP_URI}/accounts/userInfo/`, { credentials: 'include' })
                            .then(res => res.json())
                            .then(({ email }) => this.props.dispatch({ type: `emailInput`, email: email }))
                })
        }
        render() {
            return <WrappedComponent {...this.props} />;
        }
    }
}
export default withLoginCheck


// WEBPACK FOOTER //
// ./src/HOC/withLoginCheck.js